var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3BA2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2795_9440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2441 23.931V26.6207L16.5337 28L18.7559 26.6207V23.931L16.5337 25.3103L14.2441 23.931ZM26.5 14.6206L24.2778 15.9999V20.6206L20.4394 22.9654V25.6551L26.5 22V14.6206ZM6.56744 14.6206V22L12.6953 25.6551V22.9654L8.85698 20.6206V15.9999L6.56744 14.6206ZM12.6953 10.9655L10.4058 12.3448V15.0345L14.2441 17.3793V22.069L16.4663 23.4482L18.6885 22.069V17.3793L22.6617 15.0345V12.3448L20.3721 10.9655L16.5337 13.3103L12.6953 10.9655ZM22.6617 16.9654L20.4394 18.3447V21.0344L22.6617 19.6551V16.9654ZM10.4058 16.9654V19.6551L12.628 21.0344V18.3447L10.4058 16.9654ZM24.2778 8.62065L21.9882 9.99997L24.2778 11.3793V14.069L26.5 12.6897V9.99997L24.2778 8.62065ZM8.78954 8.62065L6.5 9.99997V12.6897L8.78954 14.069V11.3793L11.0118 9.99997L8.78954 8.62065ZM16.5337 8.62065L14.2441 9.99997L16.5337 11.3793L18.7559 9.99997L16.5337 8.62065ZM16.5337 4L10.4058 7.65517L12.628 9.03449L16.4663 6.68969L20.3721 9.03449L22.5943 7.65517L16.5337 4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2795_9440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 1 26.5 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.0557e9b9a69e07dff70f22c3b3dc6ea2.svg";
export { ForwardRef as ReactComponent };